import React from "react";
import Candidate from "pages/candidate";
import { Outlet } from "react-router";
import { useAuth } from "hooks";
import { SideNav } from "components/Nav";

/**
 * InterviewLayoutSwitcher
 * Layout switcher for interview response based on user type
 */
const InterviewLayoutSwitcher = () => {
  const { isCandidate } = useAuth();

  if (isCandidate)
    return (
      <Candidate>
        <Outlet />
      </Candidate>
    );

  return (
    <SideNav>
      <Outlet />
    </SideNav>
  );
};

export default InterviewLayoutSwitcher;
